export default "__VITE_ASSET__Cq_MD8EG__"